/**
 * Accordion Component
 */
(function () {
  "use strict";

  const Accordion = {
    init() {
      const accordions = document.querySelectorAll("[data-accordion]");
      accordions.forEach((accordion) => this.initAccordion(accordion));
    },

    initAccordion(accordion) {
      const items = accordion.querySelectorAll("[data-accordion-item]");
      items.forEach((item, index) => {
        const button = item.querySelector("[data-accordion-button]");
        const content = item.querySelector("[data-accordion-content]");

        if (!button || !content) return;

        button.addEventListener("click", () => {
          const isOpen = item.classList.contains("open");

          // Close all items in this accordion
          items.forEach((i) => {
            i.classList.remove("open");
            const c = i.querySelector("[data-accordion-content]");
            if (c) {
              c.style.maxHeight = "0";
              c.style.opacity = "0";
            }
            const b = i.querySelector("[data-accordion-toggle]");
            if (b) b.style.transform = "rotate(0deg)";
          });

          // Toggle current item
          if (!isOpen) {
            item.classList.add("open");
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
            const toggle = button.querySelector("[data-accordion-toggle]");
            if (toggle) toggle.style.transform = "rotate(45deg)";
          }
        });
      });
    },
  };

  window.Accordion = Accordion;
})();

